import { useEffect, useRef, useState } from 'react';
import Tipseen from 'monday-ui-react-core/dist/Tipseen';
import TipseenContent from 'monday-ui-react-core/dist/TipseenContent';

const CustomTipseen = ({
  content,
  theme,
  children,
  submitButtonText,
  submitButtonColor,
  submitButtonTextColor,
  handleSubmit,
  isVisible = false,
  overrideHover = false,
  position = '',
  hideDefaultButtons = false,
}) => {
  const [isOpen, setIsOpen] = useState(isVisible);
  const [isButtonHovered, setIsButtonHovered] = useState(false);
  const [isToolTipHovered, setIsToolTipHovered] = useState(false);
  const contentRef = useRef(null);
  const buttonRef = useRef(null);

  const handleMouseEnterBtn = () => {
    if (overrideHover) return;
    setIsOpen(true);
    setIsButtonHovered(true);
  };

  const handleMouseLeaveBtn = (_e) => {
    if (overrideHover) return;
    setTimeout(() => {
      setIsButtonHovered(false);
    }, 50);
  };

  const handleMouseLeaveTooltip = () => {
    if (overrideHover) return;
    setIsToolTipHovered(false);
  };

  const handleMouseEnterTooltip = () => {
    if (overrideHover) return;
    setIsOpen(true);
    setIsToolTipHovered(true);
  };

  useEffect(() => {
    if (overrideHover) return;

    if (!isButtonHovered && !isToolTipHovered) {
      setIsOpen(false);
    }
  }, [isButtonHovered, isToolTipHovered, overrideHover]);

  useEffect(() => {
    if (submitButtonColor)
      document.documentElement.style.setProperty(
        '--custom-tipseen-bg-color',
        submitButtonColor,
      );

    if (submitButtonTextColor)
      document.documentElement.style.setProperty(
        '--custom-tipseen-text-color',
        submitButtonTextColor,
      );
  }, [submitButtonColor, submitButtonTextColor]);

  return isOpen ? (
    <Tipseen
      className={`custom__tipseen ${
        hideDefaultButtons ? 'hide_tipseen_default_btns' : ''
      }`}
      hideCloseButton
      position={position}
      content={
        <span
          ref={contentRef}
          onMouseEnter={handleMouseEnterTooltip}
          onMouseLeave={handleMouseLeaveTooltip}
        >
          <TipseenContent
            className="custom_tipseen_content "
            submitButtonText={submitButtonText}
            hideSubmit={!submitButtonText}
            onSubmit={handleSubmit}
          >
            {content}
          </TipseenContent>
        </span>
      }
      theme={theme}
    >
      <span
        ref={buttonRef}
        onMouseEnter={handleMouseEnterBtn}
        onMouseLeave={handleMouseLeaveBtn}
      >
        {children}
      </span>
    </Tipseen>
  ) : (
    <span ref={buttonRef} onMouseEnter={handleMouseEnterBtn}>
      {children}
    </span>
  );
};

export default CustomTipseen;
